import { render } from "./CreateWalletModal.vue?vue&type=template&id=bce7c4ee"
import script from "./CreateWalletModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateWalletModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/dashboard/import_modals/CreateWalletModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bce7c4ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bce7c4ee', __exports__)) {
    api.reload('bce7c4ee', __exports__)
  }
  
  module.hot.accept("./CreateWalletModal.vue?vue&type=template&id=bce7c4ee", () => {
    api.rerender('bce7c4ee', render)
  })

}


export default __exports__